<template>
  <DetailLayoutFullWidth>
    <template slot="header">
      <base-header-financial-dashboard
        :title="$t('app.icons.alerts')"
        :show-period-picker="false"
        :show-date-picker="false"
        :show-cif-empresa-picker="true"
        @change="handleChangeEvent"
        @refresh="refreshPage"
        @print="printDashboard"
      />
    </template>
    <template slot="main">
      <loading :opacity="darkMode ? 0 : 0.5" :active="isGeneralLoading" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
      <div class="print-area mt-2 md:mt-6 space-y-5">
        <div class="flex flex-wrap gap-4">
          <single-panel class="w-full flex-1 min-w-max bg-red-100 content-red-500 border border-red-600 header-red-500 dark:bg-red-800/20 dark:content-red-100" :header="$t('tipos.alerta.criticals')" :content="totalCritical"/>
          <single-panel class="w-full flex-1 min-w-max bg-yellow-50 content-yellow-500 border-yellow-500 dark:bg-yellow-600/20 dark:content-yellow-100" :header="$t('tipos.alerta.warnings')" :content="totalWarnings"/>
          <single-panel class="w-full flex-1 min-w-max bg-primary-50 content-primary-500 border-primary-500" :header="$t('tipos.alerta.informative')" :content="totalInformative"/>
          <single-panel v-if="false" class="w-full flex-1 min-w-max bg-primary-100 content-primary-500 border-primary-500" :header="$t('tipos.alerta.resol')" :content="totalResolved"/>
        </div>
        <BasePanel>
          <template slot="header">
            <h3 class="text-base text-secondary-800 dark:text-darkblue-100 font-medium">{{ $t('financial_dashboard.alert_center') }}</h3>
          </template>
          <template slot="content">
            <div  v-for="(group, indexGroup) in groupWarnings" :key="'group'+indexGroup">
              <base-collapsible-warning 
                v-if="group.idTipoImportanciaAlerta === 1 || group.idTipoImportanciaAlerta === 2"
                :type="group.warnings[0].alertType"
                class="mb-3 p-4 rounded-md" 
                customContent="rounded-lg border-none p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="font-bold" >{{group.warnings[0].ImportanciaAlerta.toUpperCase() || 'Aviso'}}: {{`${group.warnings[0].TipoAlerta} ${group.warnings.length}`}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div v-for="(warning, index) in group.warnings" 
                    :key="'warning'+index">
                    <base-alert-box
                      :title="warning.ImportanciaAlerta.toUpperCase()"
                      :subtitle="`${warning.TipoAlerta} ${warning.Titulo} ${warning.isAlertaNumerica ? `: ${warning.Detalle}` : ''}`"
                      :text-content="`${warning.isAlertaNumerica ? '' : `${warning.Detalle}`}`" 
                      :type="warning.alertType" 
                      :actions="warning.action"
                      @action-click="goWarningRoute(warning.Ruta)" />
                  </div>
                </template>
              </base-collapsible-warning>
            </div>
            <div v-for="(warning, index) in warnings" 
              :key="'info'+index">
              <base-alert-box v-if="warning.idImportanciaAlerta === 3" 
              :title="warning.ImportanciaAlerta.toUpperCase()"
              :subtitle="`${warning.TipoAlerta} ${warning.Titulo} ${warning.isAlertaNumerica ? `: ${warning.Detalle}` : ''}`"
              :text-content="`${warning.isAlertaNumerica ? '' : `${warning.Detalle}`}`" 
              :type="warning.alertType" 
              :actions="warning.action"
              @action-click="goWarningRoute(warning.Ruta)" />
            </div>
          </template>
        </BasePanel>
      </div>
    </template>
  </DetailLayoutFullWidth>
</template>

<script>
import { i18n } from '@/i18n'
import Loading from 'vue-loading-overlay'
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import SinglePanel from '@/components/SinglePanel.vue'
import colorsMixin from '@/mixins/colorsMixin'

import { getDashboardAlertas } from '@/services/dashboard/getDashboardAlertas'


export default {
  name: 'financial-dashboard',
  mixins: [colorsMixin],
  components: {
    DetailLayoutFullWidth,
    SinglePanel,
    Loading,
  },
  props: {

  },
  data () {
    return {
      warnings: []
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    clientId () {
      return this.$store.getters['dashboard/getSelectedClient'] || null
    },
    disableSelect () {
      return !this.cifEmpresa || this.isGeneralLoading 
    },
    activePeriod () {
      return this.$store.getters['financialdashboard/activePeriod']
    },
    cifEmpresa () {
      return this.$store.getters['financialdashboard/cifEmpresa']
    },
    valueDate () {
      return this.$store.getters['financialdashboard/valueDate']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    totalCritical () {
      return this.warnings.reduce((acc, warn) => acc + (warn.ImportanciaAlerta === i18n.t('tipos.alerta.critical') ? 1 : 0), 0).toString()
    },
    totalWarnings () {
      return this.warnings.reduce((acc, warn) => acc + (warn.ImportanciaAlerta === i18n.t('avisos.singular_header') ? 1 : 0), 0).toString()
    },
    totalInformative () {
      return this.warnings.reduce((acc, warn) => acc + (warn.ImportanciaAlerta === i18n.t('tipos.alerta.info') ? 1 : 0), 0).toString()
    },
    groupWarnings () {
      const grouped = this.warnings.reduce((acc, warn) => {
        let warningGroup = acc.find(x => x.idTipoImportanciaAlerta === warn.idImportanciaAlerta && x.idTipoAlerta === warn.idTipoAlerta) 
        if (!warningGroup) {
          warningGroup = { idTipoImportanciaAlerta: warn.idImportanciaAlerta, idTipoAlerta: warn.idTipoAlerta, warnings: [] }
          acc.push(warningGroup)
        }
        warningGroup.warnings.push(warn)
        return acc
      }, [])
      grouped.sort((a, b) => {
        return a.idTipoImportanciaAlerta - b.idTipoImportanciaAlerta
      })
      return grouped
    },
    tiposAlertaEstado () {
      return this.$store.getters['config/TIPOS_ALERTA_ESTADO']
    },
    tiposAviso () {
      return this.$store.getters['config/TIPOS_AVISO']
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
  },
  mounted: async function () {
    
  },
  
  watch: {},
  methods: {
    async getDashboardAlertas (period=this.activePeriod) {
      try {
        this.$store.commit('setIsLoading', true)
        const params ={
          idCifEmpresa: this.cifEmpresa?.IdCIFEmpresa ?? null,
        }
        const dataWarnings = await getDashboardAlertas(params)
        if (!dataWarnings.blnError) {
          this.warnings = []
          dataWarnings.Response.map((warn) => {
            const warningStatus = this.tiposAlertaEstado.find(t => t.id === warn.ImportanciaAlerta)
            const warningType = this.tiposAviso.find(t => t.TipoAviso === warn.TipoAlerta)
            this.warnings.push({
              // ...warn,
              Detalle: warn.Detalle || '',
              ImportanciaAlerta: warningStatus.name ?? warn.ImportanciaAlerta.toString(),
              TipoAlerta: warningType?.Mensaje ?? warn.TipoAlerta,
              idTipoAlerta: warn.TipoAlerta,
              idImportanciaAlerta: warn.ImportanciaAlerta,
              alertType: warningStatus?.alertType ?? 'error',
              Titulo: warn.Titulo || '',
              Ruta: warn.Ruta,
              isAlertaNumerica: warn.TipoAlerta !== 3 && warn.TipoAlerta !== 7 && warn.TipoAlerta !== 8,
              action: [{
                text: i18n.t('app.show_detail'),
                type: 'button',
                route: { name: warn.Ruta },
                target: '_blank'
              }]
            })
          })
        } else {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataWarnings))
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    handleChangeEvent ({ field, value, refresh }) {
      if (field === 'cifEmpresa' && refresh) {
        this.refreshPage()
      }
    },
    async refreshPage () {
      await this.getDashboardAlertas()
    },
    goWarningRoute (ruta) {
      const data = { filters: [] }
      if (ruta === 'importacionesError') {
        data.filters.push({ type: 'tipoImportacionEstado', data: { value: 2, label: i18n.t('imports.status') } })
        this.$router.push({ name: 'configurations/imports', params: { data: data }, })
      } else {
        const privateBase = `${process.env.VUE_APP_ROUTE_BASE}`
        this.$router.push({ path: `/${privateBase}/${ruta}` })
      }
    },
    printDashboard () {
      const printArea = this.$el.querySelector('.print-area')
      if (!printArea) return

      const oldIframe = document.getElementById('printeriframe')
      if (oldIframe) oldIframe.remove()

      const clone = printArea.cloneNode(true)

      const button = clone.querySelectorAll('.cbutton')
      if (button) button.forEach(btn => btn.remove())

      const iframe = document.createElement('iframe')
      iframe.setAttribute('id', 'printeriframe')
      iframe.setAttribute('width', '768px')
      iframe.style.display = 'none'
      document.body.appendChild(iframe)

      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document

      const allStyles = [...document.querySelectorAll('link[rel="stylesheet"], style')]
        .map(el => el.outerHTML).join('\n')

      iframeDoc.open()
      iframeDoc.write(`<!DOCTYPE html><html><head><meta charset="utf-8">${allStyles}</head><body>${clone.outerHTML}</body></html>`)
      iframeDoc.close()

      const printStyle = iframeDoc.createElement('style')
      printStyle.textContent = `
        @page { 
          size: A4; 
          margin: 10mm;
        }
        @media print {
          .print-area { 
            shadow: none !important; 
          }
          .kpi-card {
              break-inside: avoid;
              page-break-inside: avoid;
          }
        }
        *, *::before, *::after { 
          box-sizing: border-box; 
        }
        html, body {
          width: 100%;
          height: auto;
          margin: 0;
          padding: 0;
          overflow: visible;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .print-area {
          width: 100%;
          padding: 0;
          margin: 0;
        }
        `
      iframeDoc.head.appendChild(printStyle)

      setTimeout(() => {
        try {
          iframe.contentWindow.focus()
          iframe.contentWindow.print()
        } catch (e) {
          console.error('Error al imprimir:', e)
        }
        setTimeout(() => iframe.remove(), 1000)
      }, 300)
    },
  }
}
</script>
<style scoped>
@media print {
  body * {
    visibility: hidden;
  }
  .print-area,.print-area * {
    visibility: visible;
  }
  .print-area {
    left: 0;
    top: 0;
    width: 100%;
  }
}
</style>
